// @flow

import { push } from 'connected-react-router'
import qs from 'qs'
import {
  checkHttpStatus,
  getApiHeaders,
  getApiBaseUrlWithOrg
} from '../utils/api'
import type { APIError } from '../types'
import type { Action } from '../types/actions/notebook'
import { getErrorAction } from '../utils/actions'
import { useSelector } from 'react-redux'

export const FETCH_NOTES_REQUEST = 'FETCH_NOTES_REQUEST'
export const FETCH_NOTES_SUCCESS = 'FETCH_NOTES_SUCCESS'
export const FETCH_NOTES_FAILURE = 'FETCH_NOTES_FAILURE'
export const UPDATE_NOTE_REQUEST = 'UPDATE_NOTE_REQUEST'
export const UPDATE_NOTE_SUCCESS = 'UPDATE_NOTE_SUCCESS'
export const UPDATE_NOTE_FAILURE = 'UPDATE_NOTE_FAILURE'
export const FETCH_PAST_NOTES_COUNT_REQUEST = 'FETCH_PAST_NOTES_COUNT_REQUEST'
export const FETCH_PAST_NOTES_COUNT_SUCCESS = 'FETCH_PAST_NOTES_COUNT_SUCCESS'
export const CLEAR_NOTEBOOK_NOTES = 'CLEAR_NOTEBOOK_NOTES'

export function fetchNotesSuccess(response: Array<Object>): Action {
  return {
    type: FETCH_NOTES_SUCCESS,
    payload: {
      notes: response.notes,
      total: response.meta.total,
      totalPages: response.meta.total_pages
    }
  }
}

export function fetchNotesFailure(error: APIError): Action {
  return getErrorAction(FETCH_NOTES_FAILURE, error)
}

export function fetchNotesRequest(): Action {
  return {
    type: FETCH_NOTES_REQUEST
  }
}

export function updateNoteSuccess(
  id: number,
  visibility: string,
  description: ?string
): Action {
  return {
    type: UPDATE_NOTE_SUCCESS,
    id: id,
    visibility: visibility,
    description: description
  }
}

export function updateNoteFailure(error: APIError): Action {
  return getErrorAction(UPDATE_NOTE_FAILURE, error)
}

export function updateNoteRequest(): Action {
  return {
    type: UPDATE_NOTE_REQUEST
  }
}

export function fetchPastNotesCountSuccess(pastNotesCount: number): Action {
  return {
    type: FETCH_PAST_NOTES_COUNT_SUCCESS,
    payload: {
      pastNotesCount
    }
  }
}

export function fetchPastNotesCountRequest(): Action {
  return {
    type: FETCH_PAST_NOTES_COUNT_REQUEST
  }
}

export function clearNotes() {
  return {
    type: CLEAR_NOTEBOOK_NOTES
  }
}

export function fetchPastNotesCount(): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const role = state.auth.isMentor ? 'mentor' : 'user'
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/${role}/user_activity_notes/total_notes_count`
    dispatch(fetchPastNotesCountRequest())

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )
      const data = await response.json()

      dispatch(fetchPastNotesCountSuccess(data.past_sections_notes_count))
    } catch (error) {
      if (error.response.status === 404) {
        dispatch(push('/notfound'))
      }

      if (error.response.status === 500) {
        dispatch(push('/error'))
      }
    }
  }
}

export function fetchNotes(
  displayPast: boolean = false,
  courseSectionId: number,
  page: number,
  masterCourseId: number
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const role = state.auth.isMentor ? 'mentor' : 'user'

    const params = qs.stringify({
      q: {
        from_past_sections: displayPast,
        from_current_sections: !displayPast,
        course_section_id_eq: courseSectionId > -1 ? courseSectionId : undefined
      },
      page
    })

    let url = ''

    if (role === 'user' && masterCourseId && masterCourseId > -1) {
      url = `${getApiBaseUrlWithOrg(
      state.organization.orgId)}/user/master_courses/${masterCourseId}/user_activity_notes?&page=${page}`
    } else {
      url = `${getApiBaseUrlWithOrg(
        state.organization.orgId)}/${role}/user_activity_notes?${params}`
    }

    dispatch(fetchNotesRequest())

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )
      const data = await response.json()

      dispatch(fetchNotesSuccess(data))

    } catch (error) {
      dispatch(fetchNotesFailure(error))

      if (error.response.status === 404) {
        dispatch(push('/notfound'))
      }

      if (error.response.status === 500) {
        dispatch(push('/error'))
      }
    }
  }
}

export function updateNote(
  id: number,
  visibility: string,
  description: ?string
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/user/compiled_quests/${state.myquest.item.id}/activities/${
      state.currentActivity.activity.id
    }/notes/${id}`

    dispatch(updateNoteRequest())

    const note: Object = {
      visibility,
      description
    }

    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            note
          })
        })
      )
      dispatch(updateNoteSuccess(id, visibility, description))
    } catch (error) {
      dispatch(updateNoteFailure(error))
    }
  }
}
